import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './ws';

ReactDOM.render(
  // <React.StrictMode>

  <App />,

  document.getElementById('root')
);
